import { useGenerateContent } from 'components/Wizards/Wizard/useGenerateContent'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { MultiStepWizard } from 'components/Wizards/MultiStepWizard/MultiStepWizard'
import { MultiStepWizardProps } from 'components/Wizards/MultiStepWizard/Types'
import { SubjectLineSelection } from './SubjectLineSelection/SubjectLineSelection'
import { SubjectLineOptionsProvider, useSubjectLineOptions } from './SubjectLineSelection/SubjectLineOptionsProvider'
import { FirstStep } from './FirstStep'
import { OutlineProvider, useOutline } from '../MultiStepBlogPostWizard/OutlineProvider'
import { SectionsSelection } from './SectionsSelection/SectionsSelection'
import { SectionsProvider } from './SectionsSelection/SectionsProvider'
import { ImagesProvider } from '../SelectImages/ImagesProvider'

const MultiStepEmailNewsletterWizard = ({ onSuccess, schema, ...props }: Omit<MultiStepWizardProps, 'onSubmit'>) => {
  const { subjectLineOptions } = useSubjectLineOptions()
  const { introduction } = useOutline()
  const { generateContent } = useGenerateContent({
    generationType: ChannelType.Newsletter,
    promptLibrary: 'default',
    onSuccess,
  })

  const handleSubmit = (values: any) => {
    const fields = {
      generation_type: ChannelType.Newsletter,
      subject_line: subjectLineOptions.find((s) => s[0] === values.selected_subject_line_id)?.[1],
      ...values,
    }

    return generateContent(fields)
  }

  return (
    <MultiStepWizard.Root {...props} onSubmit={(values) => handleSubmit(values)} schema={schema}>
      <FirstStep />
      <SubjectLineSelection />
      <SectionsSelection initialValues={{ introduction }} />
    </MultiStepWizard.Root>
  )
}

const MultiStepEmailNewsletterWizardContainer = (props: Omit<MultiStepWizardProps, 'onSubmit'>) => {
  return (
    <OutlineProvider>
      <SubjectLineOptionsProvider>
        <SectionsProvider>
          <ImagesProvider initialMaxPhotos={3}>
            <MultiStepEmailNewsletterWizard {...props} />
          </ImagesProvider>
        </SectionsProvider>
      </SubjectLineOptionsProvider>
    </OutlineProvider>
  )
}

export { MultiStepEmailNewsletterWizardContainer as MultiStepEmailNewsletterWizard }
